import { Box } from '@mui/system'
import React from 'react'
import { useSelector } from 'react-redux'
import { getFilterUsersBatchActionsStatusList, getSortUsersBatchActionsStatusList } from '../../../redux/features/usersBatchActionsStatus/usersBatchActionsStatusThunk'
import { selectUsersBatchActionsStatus } from '../../../redux/features/usersBatchActionsStatus/usersBatchActionsStatusSlice'
import SortByList from '../../../components/PageHelpers/Sort'
import FilterBy from '../../../components/PageHelpers/FilterBy'
import ActiveFilters from '../../../components/PageHelpers/ActiveFilters'

const Desktop = () => {
  const usersBatchActionsStatusStore = useSelector(selectUsersBatchActionsStatus)

  return (
    <Box>

      <Box sx={styles.sortAndFilters}>
        <SortByList
          actionToDispatch={getSortUsersBatchActionsStatusList}
          store={usersBatchActionsStatusStore}
        />
        <FilterBy
          actionToDispatch={getFilterUsersBatchActionsStatusList}
          store={usersBatchActionsStatusStore}
        />

      </Box>

      <ActiveFilters
        store={usersBatchActionsStatusStore}
        actionToDispatch={getFilterUsersBatchActionsStatusList}
      />
    </Box>
  )
}

const styles = {
  sortAndFilters: { display: { xs: 'none', sm: 'flex' }, justifyContent: 'end', my: '10px' },
}

export default Desktop
